import SceneSupervision from './SceneSupervision.vue'
export default SceneSupervision
